import Base from "../base";

//同一建物グループ
export interface SameBuildingGroup extends Base {
  id: number; //ID
  agreement_id: number; //'契約ID',
  name: string; //'グループ名',
}

export const DefaultSameBuildingGroup = (): SameBuildingGroup => ({
  id: 0,
  agreement_id: 0,
  name: "",
  created_at: "",
  updated_at: "",
  deleted_at: ""
});
